import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  avatar: {
    backgroundColor: theme.palette.gray.dark,
    '&:hover': {
      cursor: 'pointer',
    },
  },
  menu: {
    color: 'white',
    backgroundColor: '#51575E',
  },
  item: {
    fontSize: 14,
  },
}));
